import { store } from "@/store/index";
import { ENDPOINTS } from "@/app/app-config";
import { ROUTES } from "@/app/app-constants";
import { getSecurityToken } from "@/federation/getSecurityToken";
import { pendoService } from "@/services/pendo/Pendo";
import rumService, { RUM_EVENT_TYPES, type RumEventType } from "@/utils/awsRUM/awsRUM";

interface AuthRealmDomain {
  realm: string;
  domain: string;
}

const getServiceUrl = (service: string): string => {
  const { authInfo } = store.getState() as { authInfo?: Partial<AuthRealmDomain> };
  const realm = authInfo?.realm;
  const domain = authInfo?.domain;
  if (!realm || !domain) {
    throw new Error("hostlerPoolHostServices: authInfo realm/domain not initialized");
  }
  return ENDPOINTS[realm][domain][service];
};

/**
 * The host's conformance to the Hostler Pool package's HostServices interface
 * (consumer-defines-the-interface DI). Passed to <HostlerPoolApp hostServices={...}>
 * at the lazy route. Module singleton so the prop is referentially stable.
 */
export const hostlerPoolHostServices = {
  getSecurityToken,
  getYard360Endpoint: () => getServiceUrl("Yard360Service"),
  getYardConsoleEndpoint: () => getServiceUrl("YardConsoleService"),
  getActiveBuildingCode: () => {
    const { authInfo } = store.getState() as { authInfo?: { activeBuildingCode?: string } };
    return authInfo?.activeBuildingCode || "";
  },
  routes: { hostlerPool: ROUTES.HOSTLER_POOL },
  telemetry: {
    trackPendoEvent: (eventName: string, data?: Record<string, unknown>) =>
      pendoService.trackEvent(eventName, data),
    trackRumCustomEvent: (event: {
      type: string;
      message: string;
      data?: Record<string, unknown>;
    }) =>
      rumService.customEvent({
        type: (Object.values(RUM_EVENT_TYPES) as string[]).includes(event.type)
          ? (event.type as RumEventType)
          : RUM_EVENT_TYPES.USER_ACTION,
        message: event.message,
        data: event.data,
      }),
  },
};
